var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8031 4.13674C12.5687 2.37109 15.4314 2.37109 17.1971 4.13674C18.9627 5.90239 18.9627 8.76508 17.1971 10.5307L11.8637 15.8641C10.8344 16.8933 9.16567 16.8933 8.13639 15.8641C7.10712 14.8348 7.10712 13.166 8.13639 12.1367L13.4697 6.80341C13.7626 6.51051 14.2375 6.51051 14.5304 6.80341C14.8233 7.0963 14.8233 7.57117 14.5304 7.86407L9.19705 13.1974C8.75357 13.6409 8.75357 14.3599 9.19705 14.8034C9.64054 15.2469 10.3596 15.2469 10.8031 14.8034L16.1364 9.47007C17.3163 8.29021 17.3163 6.37727 16.1364 5.1974C14.9565 4.01753 13.0436 4.01753 11.8637 5.1974L6.53038 10.5307C4.61414 12.447 4.61414 15.5538 6.53039 17.4701C8.44663 19.3863 11.5535 19.3863 13.4697 17.4701L18.8031 12.1367C19.096 11.8438 19.5708 11.8438 19.8637 12.1367C20.1566 12.4296 20.1566 12.9045 19.8637 13.1974L14.5304 18.5307C12.0284 21.0328 7.97176 21.0328 5.46973 18.5307C2.96769 16.0287 2.96769 11.9721 5.46972 9.47008L10.8031 4.13674Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.6a653f79.svg";
export { ForwardRef as ReactComponent };